import Grid from "@mui/material/Grid";

import {
    useCompanyLevelContent,
    useStyles
} from "components/CompanyLevel/hooks";
import {
    COMPANY_LEVEL_DIALOGS,
    CompanyLevelHeaderProps
} from "components/CompanyLevel/shared/types";

import CompanyLevelHeaderContent from "./CompanyLevelHeaderContent";

const CompanyLevelHeader = ({ currentLevel }: CompanyLevelHeaderProps) => {
    const { getIndexInfo } = useCompanyLevelContent();
    const { getGridItemCSS } = useStyles();

    return Object.values(COMPANY_LEVEL_DIALOGS).map((entry, index) => {
        const { isFirst, isLast } = getIndexInfo(index);

        return (
            <Grid
                key={`${entry}_header`}
                size={{ xs0: 3, md: 3, lg: 3 }}
                css={getGridItemCSS(isLast, true, isFirst)}
            >
                <CompanyLevelHeaderContent
                    companyLevelName={entry}
                    currentLevel={currentLevel}
                />
            </Grid>
        );
    });
};

export default CompanyLevelHeader;
